import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.claim}claimGroups`;

export interface ClaimContextSummary {
  state: string;
  claimId: string;
  sellerId: string;
  ownerId: string;
  orderId?: string;
  warrantyTypeId?: string;
  issueId?: string;
}

export interface GetClaimContextsByGroupIdQueryArgs {
  claimGroupId: string;
}

export const getClaimContextsByGroupIdRequest = ({
  claimGroupId,
}: GetClaimContextsByGroupIdQueryArgs): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${claimGroupId}/claimsSummary`,
  config: { method: SUPPORTED_METHODS.GET },
});

export const getClaimContextsByGroupIdQuery = async (
  args: GetClaimContextsByGroupIdQueryArgs,
): Promise<BackResponse<ClaimContextSummary[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<ClaimContextSummary[]>>(
      getClaimContextsByGroupIdRequest(args),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
